export default {
  // Setters
  setUserUuid(uuid) {
    localStorage.setItem('userUuid', uuid);
  },
  setIsAsc(isAsc) {
    localStorage.setItem('isAsc', isAsc);
  },
  setUserGrade(grade) {
    localStorage.setItem('userGrade', grade);
  },
  // Getters
  getUserUuid() {
    return localStorage.getItem('userUuid');
  },
  getIsAsc() {
    return localStorage.getItem('isAsc');
  },
  // Remove
  remove(key) {
    localStorage.removeItem(key);
  },
};
